/**
 * File: aria-accordion.js
 *
 * Import and initialize functions for Accordion
 */

export default {
  accordion: document.querySelector('.elementor-accordion'),
  init() {
    if (this.accordion) {
      this.render();
    }
  },
  render() {
    [...document.querySelectorAll('.elementor-accordion-title')].forEach(el => {
      const title = el.innerHTML;
      el.outerHTML = `<span class="elementor-accordion-title">${title}</span>`;
    });
    // Make every accordion content readable in VO as well.
    [...document.querySelectorAll('.elementor-accordion-item .elementor-tab-content')].forEach(content => {
      content.setAttribute('tabindex', 0);
    });
  },
};
